<template>
	<div v-if="value" class="modal-overlay">
		<div class="modal-container">
			<div class="modal-card">
				<div class="modal-title">
					<div class="icon-wifi-alert">
						<svg width="32" height="32" viewBox="0 0 24 24" fill="#294B70">
							<path
								d="M12,3C7.79,3 3.73,4.78 0.38,7.85L2.92,10.39C5.23,8.23 8.5,7 12,7A12.88,12.88 0 0,1 21.08,10.39L23.62,7.85C20.27,4.78 16.21,3 12,3M12,9C9.3,9 6.81,10 4.89,11.64L7.43,14.18C8.5,13.3 9.94,12.8 11.5,12.8H12.5C14.06,12.8 15.5,13.3 16.57,14.18L19.11,11.64C17.19,10 14.7,9 12,9M12,15A2,2 0 0,0 10,17A2,2 0 0,0 12,19A2,2 0 0,0 14,17A2,2 0 0,0 12,15Z"
							/>
						</svg>
					</div>
					網路狀況不佳
				</div>
				<div class="modal-content">
					<div class="wifi-bg-icon">
						<svg width="120" height="120" viewBox="0 0 24 24" fill="#F5F5F5">
							<path
								d="M12,3C7.79,3 3.73,4.78 0.38,7.85L2.92,10.39C5.23,8.23 8.5,7 12,7A12.88,12.88 0 0,1 21.08,10.39L23.62,7.85C20.27,4.78 16.21,3 12,3M12,9C9.3,9 6.81,10 4.89,11.64L7.43,14.18C8.5,13.3 9.94,12.8 11.5,12.8H12.5C14.06,12.8 15.5,13.3 16.57,14.18L19.11,11.64C17.19,10 14.7,9 12,9M12,15A2,2 0 0,0 10,17A2,2 0 0,0 12,19A2,2 0 0,0 14,17A2,2 0 0,0 12,15Z"
							/>
						</svg>
					</div>
					<div class="error-message">
						<p class="error-main">網路有點不穩，可能會影響點餐</p>
						<p class="error-action">點擊下方按鈕重新載入，讓點餐更順暢</p>
					</div>
					<div class="wifi-waves">
						<div class="wave-source wave-source-1">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div class="wave-source wave-source-2">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div class="wave-source wave-source-3">
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
				</div>
				<div class="modal-actions">
					<button class="refresh-btn" @click="onConfirm">重新載入</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ChunkErrorModal',
	props: {
		value: {
			required: true,
			type: Boolean,
		},
	},
	methods: {
		onConfirm() {
			this.$emit('onConfirm')
		},
	},
}
</script>

<style lang="sass" scoped>
.modal-overlay
	position: fixed
	top: 0
	left: 0
	right: 0
	bottom: 0
	width: 100vw
	height: 100vh
	background-color: rgba(0, 0, 0, 0.6)
	display: flex
	justify-content: center
	align-items: center
	z-index: 9999
	backdrop-filter: blur(4px)

.modal-container
	width: 100%
	max-width: 480px
	margin: 0 16px

.modal-card
	background: white
	border-radius: 16px
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15)
	overflow: hidden

.modal-title
	width: 100%
	font-size: 1.5rem
	display: flex
	align-items: center
	justify-content: center
	font-weight: bold
	padding: 32px 32px 16px 32px
	text-align: center

	.icon-wifi-alert
		margin-right: 12px
		display: flex
		align-items: center

.modal-content
	padding: 8px 32px 24px 32px
	position: relative
	overflow: hidden

	.wifi-bg-icon
		position: absolute
		top: 50%
		left: 50%
		transform: translate(-50%, -50%)
		opacity: 0.08
		z-index: 0

	.wifi-waves
		position: absolute
		width: 100%
		height: 100%
		top: 0
		left: 0
		pointer-events: none
		z-index: 1

		.wave-source
			position: absolute

			&.wave-source-1
				top: 20%
				left: 25%

			&.wave-source-2
				top: 60%
				right: 20%

			&.wave-source-3
				bottom: 25%
				left: 40%

			span
				position: absolute
				border: 2px solid #e0e0e0
				border-radius: 50%
				opacity: 0
				transform: translate(-50%, -50%)

				&:nth-child(1)
					width: 40px
					height: 40px
					animation: wifi-pulse 3s infinite
					animation-delay: 0s

				&:nth-child(2)
					width: 80px
					height: 80px
					animation: wifi-pulse 3s infinite
					animation-delay: 1s

				&:nth-child(3)
					width: 120px
					height: 120px
					animation: wifi-pulse 3s infinite
					animation-delay: 2s

		@keyframes wifi-pulse
			0%
				opacity: 0.6
				transform: translate(-50%, -50%) scale(0.5)
			50%
				opacity: 0.3
			100%
				opacity: 0
				transform: translate(-50%, -50%) scale(1.2)

	.error-message
		font-size: 1rem
		line-height: 1.6
		color: #424242
		text-align: center
		position: relative
		z-index: 2

		.error-main
			margin: 0 0 16px 0
			padding: 0
			font-size: 1.1rem
			color: #616161
			font-weight: 500
			letter-spacing: 0.3px

		.error-action
			margin: 0
			padding: 0
			font-size: 0.95rem
			color: #757575
			line-height: 1.5
			font-weight: 400

.modal-actions
	width: 100%
	display: flex
	align-items: center
	justify-content: center
	padding: 0 32px 32px 32px

	.refresh-btn
		width: 100%
		height: 56px
		background-color: #294B70
		color: white
		border: none
		border-radius: 8px
		font-size: 1rem
		font-weight: 500
		cursor: pointer
		transition: background-color 0.2s ease

		&:hover
			background-color: #1E3652

		&:active
			background-color: #17293F
</style>
